export type ToolEntry = {
  id: string;
  title: string;
  subtitle: string;
  meta: string;
  path: string;
  badge?: string;
};

/** Append future standalone tools here. */
export const TOOLS: ToolEntry[] = [
  {
    id: 'record',
    title: 'Ghi âm — Record',
    subtitle: 'Ghi từ micro hoặc âm thanh máy tính / tab trình duyệt',
    meta: 'Tải về file WAV',
    path: '/record',
  },
  {
    id: 'video-logo',
    title: 'Chèn logo vào video',
    subtitle: 'Upload video + logo, chọn vị trí và kích thước, xuất MP4',
    meta: 'Xử lý trên máy bạn · FFmpeg.wasm',
    path: '/tools/video-logo',
  },
  {
    id: 'convert-image',
    title: 'Đổi đuôi ảnh — PNG/JPG/WebP',
    subtitle: 'Chuyển PNG, JPG, WebP, GIF, BMP, SVG ngay trên trình duyệt',
    meta: 'Nhiều file · không cần FFmpeg',
    path: '/tools/convert-image',
  },
  {
    id: 'compress-image',
    title: 'Nén ảnh — dưới 1MB',
    subtitle: 'Giảm dung lượng bằng cách giảm chất lượng và thu nhỏ kích thước — xem trước/sau',
    meta: 'Nhiều file · Canvas · không upload',
    path: '/tools/compress-image',
    badge: 'Mới',
  },
  {
    id: 'convert-audio',
    title: 'Đổi đuôi âm thanh — MP3/WAV/OGG',
    subtitle: 'MP3, WAV, OGG, M4A, OPUS — xử lý bằng FFmpeg.wasm',
    meta: 'Không upload server',
    path: '/tools/convert-audio',
  },
  {
    id: 'convert-video',
    title: 'Đổi đuôi video — MP4/WebM/GIF',
    subtitle: 'MP4, WebM, GIF hoặc tách audio — clip ngắn khuyến nghị',
    meta: 'FFmpeg.wasm trên máy bạn',
    path: '/tools/convert-video',
    badge: 'Mới',
  },
  {
    id: 'convert-text',
    title: 'Đổi đuôi văn bản — TXT/CSV/JSON',
    subtitle: 'Encoding, xuống dòng, CSV ↔ JSON, pretty/minify JSON',
    meta: 'Thuần JS · tức thì',
    path: '/tools/convert-text',
  },
  {
    id: 'pronunciation',
    title: 'Kiểm tra phát âm — AI chấm',
    subtitle: 'Đọc theo câu mẫu, AI nhận diện và tô đỏ chỗ sai',
    meta: 'Whisper tiny trên máy bạn · luyện tập',
    path: '/tools/pronunciation',
    badge: 'Mới',
  },
];
